<template>
    <div class="production-expenses">
        <div class="production-expenses-grid" v-loading="loading">
            <template v-for="(column, index) in expenseProductionDealColumns">
                <div :key="'header_' + index" class="header-cell">
                    {{ column.headerName }}
                </div>
            </template>
            <template v-for="(expense, expenseIndex) in expenses">
                <template v-for="(column, columnIndex) in expenseProductionDealColumns">
                    <div
                        :key="expenseIndex+ '_'+ columnIndex"
                        :class="column.fieldClass"
                        :title="expense[column.field]"
                    >
                        <template v-if="column.field === 'deal_id'">
                            <a :href="getDealLink(expense[column.field])" target="_blank" class="link">
                                {{ expense[column.field] }}
                            </a>
                        </template>
                        <template v-else-if="column.field === 'amount'">
                            <span :class="{'red': expense.amount < 0}">
                                {{ formatFinance(expense[column.field]) }}
                            </span>
                        </template>
                        <template v-else>
                            {{ expense[column.field] }}
                        </template>
                    </div>
                </template>
            </template>
        </div>
        <div class="total">
            <span class="total-info">
                Итого: {{ formatFinance(expensesTotalAmount) }} руб.
            </span>
        </div>
    </div>
</template>

<script>
import { formatFinance } from '@/common/utilities';
import '@/assets/styles/expenses-production-list.scss';

export default {
    name: 'ExpenseProductionDealsGrid',
    props: {
        expenses: {
            type: Array,
            default: () => {}
        }
    },
    data() {
        return {
            expenseProductionDealColumns: [
                { headerName: 'Id сделки', field: 'deal_id', fieldClass: 'grid-cell' },
                { headerName: 'Дата замера', field: 'measurement_date', fieldClass: 'grid-cell' },
                { headerName: 'Дата монтажа', field: 'installation_date', fieldClass: 'grid-cell' },
                { headerName: 'Договор', field: 'contract', fieldClass: 'grid-cell cut-text ' },
                { headerName: 'Клиент', field: 'contact_name', fieldClass: 'grid-cell cut-text' },
                { headerName: 'Телефон клиента', field: 'contact_phone', fieldClass: 'grid-cell' },
                { headerName: 'Адрес', field: 'address', fieldClass: 'grid-cell cut-text ' },
                { headerName: 'Сумма', field: 'amount', fieldClass: 'grid-cell text-right pr10' }
            ],
            loading: false
        };
    },
    computed: {
        expensesTotalAmount() {
            return this.expenses.reduce((sum, expense) => sum + +expense.amount, 0);
        }
    },
    methods: {
        formatFinance,
        getDealLink(dealId) {
            return this.$router.resolve({ name: 'deal-card', params: { id: '' + dealId } }).href;
        }
    }
};
</script>
